import {
  ArrayField,
  SingleFieldList,
  ChipField,
  FunctionField,
} from "react-admin";

const StringArrayField = ({
  source,
  transform,
}: {
  source: string;
  transform?: (value: string) => string;
}) => (
  <ArrayField source={source}>
    <SingleFieldList>
      <FunctionField
        render={(record) => (
          <ChipField
            record={{ value: transform ? transform(record) : record }}
            source="value"
          />
        )}
      />
    </SingleFieldList>
  </ArrayField>
);

export default StringArrayField;
